import { useId, useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { InputActions } from './forms/Controls'
import styles from './PasswordInput.module.css'

export function PasswordInput({
  id,
  label,
  value,
  onChange,
  placeholder,
  required = false,
  disabled = false,
  autoComplete = 'current-password',
  autoFocus = false,
  describedBy,
  hideToggleLabel = 'Show password',
  showToggleLabel = 'Hide password',
  size = 'default',
}) {
  const generatedId = useId()
  const inputId = id || `password-${generatedId}`
  const [revealed, setRevealed] = useState(false)

  return (
    <div className={styles.field}>
      {label && (
        <label htmlFor={inputId} className={styles.label}>
          {label}
        </label>
      )}
      <InputActions
        actions={[
          <button
            key="toggle"
            type="button"
            className={styles.toggle}
            onClick={() => setRevealed((prev) => !prev)}
            disabled={disabled}
            aria-label={revealed ? showToggleLabel : hideToggleLabel}
          >
            {revealed ? <EyeOff size={16} aria-hidden="true" /> : <Eye size={16} aria-hidden="true" />}
          </button>,
        ]}
      >
        <input
          id={inputId}
          type={revealed ? 'text' : 'password'}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          required={required}
          disabled={disabled}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          aria-describedby={describedBy}
          data-size={size}
          className={`${styles.input} ${size === 'large' ? styles.inputLarge : ''}`}
        />
      </InputActions>
    </div>
  )
}
